const fileDownloadButtonTreeNode = {
  title: 'Gerar qrcode para esse ramo',
  cutOut: 'Recortar',
  paste: 'Colar'
};

export default fileDownloadButtonTreeNode;
